import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";
import api from "@/lib/api";

export const GlobalSearch = () => {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState("");
    const [groups, setGroups] = useState([]);
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const timer = useRef(null);

    useEffect(() => {
        if (open) setTimeout(() => inputRef.current?.focus(), 80);
        else { setQ(""); setGroups([]); }
    }, [open]);

    useEffect(() => {
        clearTimeout(timer.current);
        if (q.trim().length < 2) { setGroups([]); return; }
        timer.current = setTimeout(() => {
            api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setGroups(r.data.groups)).catch(() => {});
        }, 250);
    }, [q]);

    const go = (url) => {
        setOpen(false);
        if (url.startsWith("/hearing-aids/")) window.location.href = url;
        else navigate(url);
    };

    return (
        <>
            <button onClick={() => setOpen(true)} aria-label="Search" data-testid="global-search-btn"
                className="p-2 rounded-full hover:bg-black/5 text-[#003E4D]">
                <Search size={18} />
            </button>
            {open && (
                <div className="fixed inset-0 z-[100] bg-black/50 flex items-start justify-center pt-[10vh] px-4" onClick={() => setOpen(false)} data-testid="search-overlay">
                    <div className="bg-white rounded-2xl w-full max-w-[640px] shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center gap-3 px-5 py-4 border-b border-[#efece6]">
                            <Search size={18} className="text-[#4a5568]" />
                            <input ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input"
                                placeholder="Search products, articles, cities, PIN codes…"
                                className="flex-1 outline-none text-[15.5px]" />
                            <button onClick={() => setOpen(false)} aria-label="Close search"><X size={18} className="text-[#4a5568]" /></button>
                        </div>
                        <div className="max-h-[55vh] overflow-y-auto" data-testid="search-results">
                            {groups.length === 0 && q.trim().length >= 2 && (
                                <p className="px-5 py-6 text-[14px] text-[#4a5568]">No matches — try a model name (e.g. "7IX"), a city, or a symptom (e.g. "whistling").</p>
                            )}
                            {groups.map((g) => (
                                <div key={g.type} className="px-5 py-3">
                                    <p className="text-[11px] uppercase tracking-wider text-[#B8860B]">{g.type}</p>
                                    {g.items.map((it, i) => (
                                        <button key={i} onClick={() => go(it.url)} data-testid={`search-result-item`}
                                            className="block w-full text-left py-2 text-[14.5px] text-[#1a1a1a] hover:text-[#0F6B7D]">
                                            {it.title}
                                        </button>
                                    ))}
                                </div>
                            ))}
                            {q.trim().length < 2 && (
                                <p className="px-5 py-6 text-[13.5px] text-[#9CA3AF]">Try: "Styletto 7IX", "hearing aid price in Mumbai", "400050", "battery draining"…</p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GlobalSearch;
